import { User } from '@graphics/gfx-common/dist/types'

export enum types {
  SCHEDULE_MODAL_OPEN = 'SCHEDULE_MODAL_OPEN',
  SCHEDULE_MODAL_CLOSE = 'SCHEDULE_MODAL_CLOSE',
  SCHEDULE_DELETE_MODAL_OPEN = 'SCHEDULE_DELETE_MODAL_OPEN',
  SCHEDULE_DELETE_MODAL_CLOSE = 'SCHEDULE_DELETE_MODAL_CLOSE',
  SET_FIELD_VALUE = 'SET_FIELD_VALUE',
  SET_FORM_ERRORS = 'SET_FORM_ERRORS',
  SCHEDULE_REQUEST__START = 'SCHEDULE_REQUEST__START',
  SCHEDULE_REQUEST__FINISH = 'SCHEDULE_REQUEST__FINISH',
  SCHEDULE_REQUEST__START__SUCCESS = 'SCHEDULE_REQUEST__START__SUCCESS',
  SCHEDULE_REQUEST__START__FAILURE = 'SCHEDULE_REQUEST__START__FAILURE',
  CLEAR_FORM_ERRORS = 'CLEAR_FORM_ERRORS',
  GET_SCHEDULES = 'GET_SCHEDULES',
  GET_SCHEDULES__SUCCESS = 'GET_SCHEDULES__SUCCESS',
  GET_SCHEDULES__FAILURE = 'GET_SCHEDULES__FAILURE',
}

export interface IModalOpenAction {
  type: types.SCHEDULE_MODAL_OPEN
  currentScheduleId?: string
  defaultFieldValues?: Partial<IFormFields>
}

export interface IModalCloseAction {
  type: types.SCHEDULE_MODAL_CLOSE
}
export interface IDeleteModalOpenAction {
  type: types.SCHEDULE_DELETE_MODAL_OPEN
  currentScheduleId: string
}

export interface IDeleteModalCloseAction {
  type: types.SCHEDULE_DELETE_MODAL_CLOSE
}

export interface ISetFieldValueAction {
  type: types.SET_FIELD_VALUE
  value: any
  fieldName: FieldNames
}

export interface ISetFormErrorsAction {
  type: types.SET_FORM_ERRORS
  fieldErrors: IPublishScheduleFormErrors
}

export interface IClearFormErrorsAction {
  type: types.CLEAR_FORM_ERRORS
}

export interface IScheduleRequestStart {
  type: types.SCHEDULE_REQUEST__START
}

export interface IScheduleRequestFinish {
  type: types.SCHEDULE_REQUEST__FINISH
}

export interface IGetSchedules {
  type: types.GET_SCHEDULES
}

export interface IGetSchedulesSuccess {
  type: types.GET_SCHEDULES__SUCCESS
  schedules: IScheduleRecord[]
}

export interface IGetSchedulesFailure {
  type: types.GET_SCHEDULES__FAILURE
}

export type IPublishScheduleActionType =
  | IModalOpenAction
  | IModalCloseAction
  | IDeleteModalOpenAction
  | IDeleteModalCloseAction
  | ISetFieldValueAction
  | ISetFormErrorsAction
  | IClearFormErrorsAction
  | IScheduleRequestStart
  | IScheduleRequestFinish
  | IGetSchedules
  | IGetSchedulesSuccess
  | IGetSchedulesFailure

export interface IScheduleDataBasic {
  startTime?: string
  intradayRepeat: boolean
  intradayRepeatInterval: string | null
  intradayRepeatUntil: string | null
  recurring?: boolean
  rrule: string | null
}

export interface IScheduleData extends IScheduleDataBasic {
  group: string
  type: string
  index: boolean
  created?: string
  createdBy?: User
  modified?: string
  modifiedBy?: User
}

export interface IScheduleRecord {
  graphicId: string
  scheduleId: string
  group: string
  type: string
  startTime: string
  index: boolean
  intradayRepeat: boolean
  intradayRepeatInterval: string | null
  intradayRepeatUntil: string | null
  recurring: boolean
  rrule: string | null
  created: string
  createdBy: User
  modified: string
  modifiedBy: User
}

export interface IFormFields {
  startTime?: Date | null
  recurrence: RecurrenceTypes
  recurrenceVariant: RecurrenceVariantTypes
  recurrenceDayNumber: number | null
  recurrenceWeekday: WeekdayTypes
  recurrenceWeekdayCount: number
  recurrenceWeekdays: WeekdayTypes[]
  recurrenceMonth: MonthTypes,
  period: PeriodTypes
  everyNthPeriod: number | null
  occurrences: number | null
  endTime?: Date | null,
  intradayRepeat: IntradayRepeatTypes,
  intradayRepeatInterval: string,
  intradayRepeatUntil?: Date | null,
  utc?: boolean
}

export interface IFormFieldsValidated extends IFormFields {
  startTime: Date
  recurrenceDayNumber: number
  recurrenceWeekdayCount: number
  everyNthPeriod: number
  occurrences: number
  intradayRepeatUntil?: Date
  endTime?: Date
}

export interface IPublishScheduleFormErrors {
  startTime?: string
  recurrenceDayNumber?: string
  everyNthPeriod?: string
  occurrences?: string
  intradayRepeatUntil?: string
  endTime?: string
}

export interface IPublishScheduleFormState {
  fieldValues: IFormFields
  fieldErrors: IPublishScheduleFormErrors
  displayModal: boolean
  displayDeleteModal: boolean
  isRequestInProgress: boolean
  currentScheduleId?: string
  schedules: IScheduleRecord[]
  schedulesLoading: boolean
  schedulesLoaded: boolean
}

export enum FieldNames {
  startTime = 'startTime',
  recurrence = 'recurrence',
  recurrenceVariant = 'recurrenceVariant',
  recurrenceDayNumber = 'recurrenceDayNumber',
  recurrenceWeekday = 'recurrenceWeekday',
  recurrenceWeekdays = 'recurrenceWeekdays',
  recurrenceWeekdayCount = 'recurrenceWeekdayCount',
  recurrenceMonth = 'recurrenceMonth',
  everyNthPeriod = 'everyNthPeriod',
  period = 'period',
  occurrences = 'occurrences',
  endTime = 'endTime',
  intradayRepeat = 'intradayRepeat',
  intradayRepeatInterval = 'intradayRepeatInterval',
  intradayRepeatUntil = 'intradayRepeatUntil',
  utc = 'utc',
}

export enum RecurrenceTypes {
  none = 'none',
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
  yearly = 'yearly',
}

export enum PeriodTypes {
  forever = 'forever',
  untilOccurrence = 'untilOccurrence',
  untilDate = 'untilDate',
}

export enum RecurrenceVariantTypes {
  dayByNumber = 'dayByNumber',
  dayByName = 'dayByName',
}

export enum IntradayRepeatTypes {
  none = 'none',
  repeat = 'repeat',
  repeatAllDay = 'repeatAllDay',
}

export enum WeekdayTypes {
  Monday, Tuesday, Wednesday, Thursday, Friday, Saturday, Sunday,
}

export enum MonthTypes {
  January = 1, February, March, April, May, June, July, August, September, October, November, December,
}

export interface ISelectOption<T> {
  value: T
  label: string
}
